
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import { ReviewBoxCurriculumUnit } from '@/models/CurriculumUnit'

/**
 * 復習BOX内のコンテンツ
 */
@Component({
  components: {
    ImageBase,
    PanelFrame,
  },
})
export default class ReviewBoxContent extends Vue {
  /** 単元情報一覧 */
  @Prop()
  private curriculumUnit!: ReviewBoxCurriculumUnit

  /** 単元一覧の通し番号 */
  @Prop()
  private titleNumber!: number

  /**
   * 単元クリックイベントの発火を親コンポーネントに追加
   *
   * @param event イベントオブジェクト
   */
  private clickCurriculumUnit(event: Event): void {
    this.$emit('click', event)
  }
}
